// extracted by mini-css-extract-plugin
export var container = "_6d-0";
export var error = "_6d-9";
export var label = "_6d-5";
export var light = "_6d-6";
export var md = "_6d-3";
export var sm = "_6d-2";
export var thin = "_6d-8";
export var thinBold = "_6d-7";
export var vertical = "_6d-4";
export var xs = "_6d-1";